import { inferSwingPosition, isSegmentationPosition, Segmentation } from '@core';
import { GraphLineNode } from '@data';
import { CorridorDataPoint } from '@ui';

export type CorridorDataPoints = (Omit<CorridorDataPoint, 'frame'> & { position: string | null })[];

export const createCorridorDataPoints = (
    graphLines: GraphLineNode[],
    corridorsByGraphLine: Record<string, CorridorDataPoints>,
    segmentation: Segmentation,
): Record<string, CorridorDataPoint[]> => {
    return Object.fromEntries(
        graphLines.map(
            (graphLine) =>
                [
                    graphLine.id,
                    (corridorsByGraphLine[graphLine.id] ?? []).flatMap((corridorMargin) => {
                        const position = corridorMargin.position ?? inferSwingPosition(corridorMargin.name);
                        if (!position) return [];
                        const segmentationPosition = position.toUpperCase();
                        if (!isSegmentationPosition(segmentationPosition)) return [];
                        return [{ frame: segmentation[segmentationPosition], ...corridorMargin }];
                    }),
                ] as const,
        ),
    );
};
